export default function SectionLabel({ children, color = "#E06B3F" }) {
  return (
    <p
      className="text-xs uppercase tracking-[0.25em] font-semibold mb-6"
      style={{ color }}
    >
      <span className="inline-block w-8 h-px align-middle mr-3" style={{ background: color }} />
      {children}
    </p>
  );
}
